import { useEffect, useState } from "react";
import { getOrderById } from "../../apis/orderApi";
import { updateProductInStudent } from "../../apis/studentApi";
import toast from "react-hot-toast";
import { uploadFile } from "../../apis/authApi";
import ProductDropdown from "../ProductDropdown";
import { MdDelete } from "react-icons/md";

const EditModel = ({ studentId, orderId, products, setEdit }) => {
  const [cart, setCart] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [quantity, setQuantity] = useState("");
  const [description, setDescription] = useState("");
  const [order, setOrder] = useState({});
  const [student, setStudent] = useState({});
  const [industryTypes, setIndustryTypes] = useState([]);
  const [error, setError] = useState("");
  const [price, setPrice] = useState("");
  const [measurement, setMeasurement] = useState("");
  const [cashAmount, setCashAmount] = useState(0);
  const [gpayAmount, setGpayAmount] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [discountType, setDiscountType] = useState("none");
  const [discountAmount, setDiscountAmount] = useState(0);
  const [paymentFile, setPaymentFile] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState("");
  const [takenBy, setTakenBy] = useState("");

  useEffect(() => {
    if (orderId) {
      getOrderById(orderId)
        .then((res) => {
          const student = res.data.students.find(
            (stu) => stu._id === studentId
          );
          setStudent(student);
          setCart(student.products);
          setOrder(res.data);
        })
        .catch(() => setError("Error fetching order details"));
    }
  }, [orderId]);

  useEffect(() => {
    if (!selectedInvoice || !student) return;

    const invoice = student.invoices?.find((i) => i?._id === selectedInvoice);

    setCart(invoice?.products ?? []);

    const amount = (method) => {
      return (
        invoice?.paymentDetails?.payments?.reduce((acc, cur) => {
          return cur.method === method ? acc + cur.amount : acc;
        }, 0) ?? 0
      );
    };

    const disamount =
      invoice?.paymentDetails?.payments?.reduce((acc, cur) => {
        return acc + (cur.discount ?? 0);
      }, 0) ?? 0;

    // console.log(disamount)

    setCashAmount(amount("cash"));
    setGpayAmount(amount("gpay"));
    setDiscountType("flat");
    setDiscount(disamount);
    setDiscountAmount(disamount);
  }, [selectedInvoice, student]);

  const addToCart = () => {
    if (!selectedProduct || !quantity) {
      return alert("Please select a product and quantity");
    }

    if (selectedProduct === "custom" && (!price || !measurement)) {
      return alert("Please provide all details for the custom product");
    }

    const product =
      selectedProduct === "custom"
        ? { name: "Custom Product", price: parseFloat(price), measurement }
        : products.find((p) => p._id === selectedProduct);

    const newCartItem = {
      product: selectedProduct === "custom" ? null : selectedProduct,
      description,
      measurement: selectedProduct === "custom" ? measurement : null,
      price: price,
      quantity: parseInt(quantity, 10),
      // totalPrice: product.price * parseInt(quantity, 10),
      custom: selectedProduct === "custom",
    };

    setCart((prev) => [...prev, newCartItem]);
    setSelectedProduct("");
    setQuantity("");
    setDescription("");
    setMeasurement("");
    setError("");
    setPrice("");
  };
  const removeFromCart = (index) => {
    setCart((prevCart) => prevCart.filter((_, i) => i !== index));
  };
  const subTotal = cart.reduce((acc, item) => {
    const price = item.price
      ? Number(item.price)
      : Number(products.find((p) => p._id === item.product)?.price || 0);
    return acc + price * Number(item.quantity);
  }, 0);

  const total = Math.max(subTotal - discount, 0);
  const handleSubmit = () => {
    if (cart.length === 0) {
      toast.error("Please add products to the cart");
      return;
    }

    if (!selectedInvoice) {
      toast.error("Please select invoice");
      return;
    }

    const isConfirm = window.confirm(
      "Are you sure to edit please check it once then update"
    );

    if (!isConfirm) return;
    let proffUrl = "";
    const formData = new FormData();
    formData.append("file", paymentFile);
    uploadFile(formData)
      .then((res) => {
        proffUrl = res.data.url;
      })
      .catch((err) => console.error(err));
    const cashVal = Number(cashAmount);
    const gpayVal = Number(gpayAmount);
    let dynamicMethod = "";
    if (cashVal > 0 && gpayVal > 0) {
      dynamicMethod = "cash & gpay";
    } else if (gpayVal > 0) {
      dynamicMethod = "gpay";
    } else if (cashVal > 0) {
      dynamicMethod = "cash";
    }

    const studentInvoice = student?.invoices?.map((inv) => {
      if (inv._id === selectedInvoice) {
        inv.products = cart;
        inv.paymentDetails = {
          method: dynamicMethod,
          balance: total - (Number(cashAmount) + Number(gpayAmount)),
          totalPrice: total,
          date: Date.now(),
          payments: [
            { amount: cashAmount, method: "cash" },
            {
              amount: gpayAmount,
              method: "gpay",
              proffOfPayment: proffUrl,
              discount,
            },
          ],
        };
      }
      return inv;
    });
    const studentProducts = studentInvoice.flatMap((s) => s.products);
    const stutotal = studentProducts.reduce((acc, item) => {
      return (acc += item.price
        ? item.price * item.quantity
        : products.find((pro) => pro._id === item.product)?.price *
          item.quantity);
    }, 0);
    const studentBalance = studentInvoice.reduce((acc, inv) => {
      return (acc += inv.paymentDetails.balance);
    }, 0);

    updateProductInStudent(orderId, studentId, {
      products: studentProducts,
      paymentDetails: {
        method: dynamicMethod,
        balance: studentBalance,
        totalPrice: stutotal,
        date: Date.now(),
        payments: studentInvoice.flatMap(
          (inv) => inv.paymentDetails?.payments || []
        ),
      },
      invoice: selectedInvoice,
      invoicePayment: {
        method: dynamicMethod,
        balance: total - (Number(cashAmount) + Number(gpayAmount)),
        totalPrice: total,
        date: Date.now(),
        payments: [
          { amount: cashAmount, method: "cash" },
          {
            amount: gpayAmount,
            method: "gpay",
            proffOfPayment: proffUrl,
            discount,
          },
        ],
      },
      takenBy,
      invoiceProducts: cart,
    })
      .then((res) => {
        toast.success(res.message);
        setEdit(false);
        setSelectedInvoice("");
      })
      .catch((err) => {
        console.log(err);
        toast.error("soming went worng");
      });
  };
  useEffect(() => {
    const cartTotal = subTotal;

    let discountValue = discountAmount;
    if (discountType === "percentage") {
      discountValue = 5;
      setDiscountAmount(5);
    }
    if (discountType === "percentage") {
      // Cap percentage at 100
      const percentage = Math.min(discountAmount, 100);
      discountValue = (cartTotal * percentage) / 100;
    }

    setDiscount(Math.round(discountValue));
  }, [discountAmount, discountType, subTotal]);

  // console.log(student)
  return (
    <>
      {/* <div className=" flex justify-between">
        <h2 className="text-xl font-bold mb-4">Edit Order</h2>
        <p>Name : {student?.name}</p>
      </div> */}

      <div
        className={`${
          selectedProduct === "custom" && " grid grid-cols-2 gap-2"
        }`}
      >
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Invoices</label>

          <select
            className="border rounded-lg py-1 px-4 w-full"
            value={selectedInvoice}
            onChange={(e) => setSelectedInvoice(e.target.value)}
          >
            <option value="" selected disabled>
              Choose a invoice
            </option>
            {student?.invoices &&
              student.invoices?.map((product) => (
                <option key={product._id} value={product._id}>
                  {product.invoiceNo}
                </option>
              ))}
          </select>
        </div>

        <ProductDropdown
          products={products}
          selectedProduct={selectedProduct}
          setSelectedProduct={setSelectedProduct}
        />

        {/* {selectedProduct && (
              <button
                className=" p-1 absolute right-10 top-16 text-sm bg-primary rounded-md text-white"
                onClick={() => setCustom(!custom)}
              >
                Custom
              </button>
            )} */}
        {selectedProduct === "custom" && (
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">
              Measurement
            </label>
            <input
              type="text"
              className="border rounded-lg py-2 px-4 w-full"
              value={measurement}
              onChange={(e) => setMeasurement(e.target.value)}
            />
          </div>
        )}
        {selectedProduct === "custom" && (
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Price</label>
            <input
              type="number"
              className="border rounded-lg py-2 mb-4 px-4 w-full"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
          </div>
        )}
        {/* Quantity Input */}
        {selectedProduct && (
          <div className="mb-4">
            <div className=" flex justify-between items-center">
              <label className="block text-sm font-medium mb-1">Quantity</label>
              {selectedProduct !== "custom" ? (
                <span>
                  {quantity *
                    products.find((pro) => pro._id === selectedProduct).price}
                </span>
              ) : (
                <span>{quantity * price}</span>
              )}
            </div>
            <input
              type="number"
              className="border rounded-lg py-2 px-4 w-full"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
            />
          </div>
        )}
      </div>
      {selectedProduct && (
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">
            Description ( Optional )
          </label>
          <textarea
            type="text"
            className="border rounded-lg py-2 px-4 w-full"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
      )}
      {/* Add to Cart Button */}
      {selectedProduct && quantity && (
        <button
          className="w-full py-2 bg-primary text-white rounded-lg text-sm font-medium mb-4"
          onClick={addToCart}
        >
          Add to List
        </button>
      )}
      {/* Cart Display */}
      {cart.length > 0 && (
        <div className="mb-4">
          <h3 className="text-lg font-semibold">Products</h3>
          <ul>
            {cart.map((item, index) => (
              <li key={index} className="flex justify-between items-center">
                <span className="mr-auto">
                  {item.product
                    ? products.find((pro) => pro._id === item.product)?.name
                    : "Custom"}{" "}
                  (x{item.quantity}){" "}
                  {item.description && <em>({item.description})</em>}
                  {item.measurement && (
                    <>
                      <em>({item.measurement})</em>
                      <span className=" bg-primary text-white text-xs ml-2 rounded-md px-2 py-1">
                        custom
                      </span>
                    </>
                  )}
                </span>
                <span>
                  &#8377;{" "}
                  {item.price
                    ? item.price * item.quantity
                    : products.find((pro) => pro._id === item.product)?.price *
                      item.quantity}
                </span>
                <button
                  className="text-red-500 ml-3"
                  onClick={() => removeFromCart(index)}
                >
                  <MdDelete />
                </button>
              </li>
            ))}
          </ul>
          <hr className="my-2" />
          <div className="flex justify-between font-bold">
            <span>Total:</span>
            <span>
              &#8377;{" "}
              {cart.reduce((acc, item) => {
                return (acc += item.price
                  ? item.price * item.quantity
                  : products.find((pro) => pro._id === item.product)?.price *
                    item.quantity);
              }, 0)}
            </span>
          </div>
        </div>
      )}
      <div>
        <h1 className=" font-bold">Payment Detail</h1>
        <div className=" flex flex-col gap-3">
          <label htmlFor="discount" className="block font-semibold mb-2">
            Discount
          </label>

          <div className="flex gap-4 mb-3">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="discountType"
                value="percentage"
                checked={discountType === "percentage"}
                onChange={(e) => setDiscountType(e.target.value)}
              />
              Percentage (%)
            </label>

            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="discountType"
                value="flat"
                checked={discountType === "flat"}
                onChange={(e) => setDiscountType(e.target.value)}
              />
              Flat Amount
            </label>
          </div>
          <div>
            Discount :
            <input
              type="number"
              className=" border-2 p-1 border-black w-fit"
              value={discountAmount}
              onChange={(e) => {
                let inputValue = e.target.value;
                if (typeof inputValue === "number") return;
                if (inputValue < 0) return;
                if (discountType === "percentage" && inputValue === 5) return;
                setDiscountAmount(inputValue);
              }}
              placeholder={
                discountType === "percentage"
                  ? "Enter discount %"
                  : "Enter flat amount"
              }
              disabled={discountType === "percentage"}
            />
          </div>
          <div>
            Cash :{" "}
            <input
              type="number"
              value={cashAmount}
              onChange={(e) => setCashAmount(e.target.value)}
              className=" border-2 p-1 border-black"
            />
          </div>
          <div>
            Gpay :{" "}
            <input
              type="number"
              value={gpayAmount}
              onChange={(e) => setGpayAmount(e.target.value)}
              className=" border-2 p-1 border-black"
            />{" "}
          </div>
          <div>
            Need to pay (Balance):{" "}
            {Math.round(
              Number(total - (Number(cashAmount) + Number(gpayAmount)))
            )}
          </div>
          {/* <div>Prev Discount: {student?.invoices?.find(i=>i?._id === selectedInvoice)?.paymentDetails}</div> */}
          {selectedInvoice && (
            <>
              {/* <div>You need pay: {total-((student?.invoices?.find(i=>i?._id === selectedInvoice)?.paymentDetails?.totalPrice??0)).toFixed(2)}</div> */}
              <div>--------------------------------</div>
              <div>
                Prev Paid Amount:{" "}
                {student?.invoices?.find((i) => i?._id === selectedInvoice)
                  ?.paymentDetails?.totalPrice -
                  student?.invoices?.find((i) => i?._id === selectedInvoice)
                    ?.paymentDetails?.balance}
              </div>
              <div>
                Prev Balance Amount:{" "}
                {
                  student?.invoices?.find((i) => i?._id === selectedInvoice)
                    ?.paymentDetails?.balance
                }
              </div>
              <div>--------------------------------</div>
            </>
          )}
          <label htmlFor="payment" className=" block font-semibold">
            Payment Attachment
          </label>
          <input
            type="file"
            className="border rounded-lg py-2 mb-4 px-4 w-full"
            // value={paymentFile}
            onChange={(e) => setPaymentFile(e.target.files[0])}
          />
          {paymentFile && (
            <a
              target="_blank"
              className=" text-white rounded-md p-2 px-3 bg-blue-600"
              href={URL.createObjectURL(paymentFile)}
            >
              View File
            </a>
          )}
          <label htmlFor="tailor" className=" block font-semibold">
            Tailor
          </label>
          <input
            type="text"
            className="border rounded-lg py-2 mb-4 px-4 w-full"
            value={takenBy}
            onChange={(e) => setTakenBy(e.target.value)}
          />
        </div>
      </div>
      <div className=" flex justify-end mt-2">
        <button
          className=" bg-primary text-white px-2 py-1 rounded-md shadow-md"
          onClick={handleSubmit}
        >
          Update
        </button>
      </div>
    </>
  );
};

export default EditModel